<template>
  <el-dialog title="全量发布" center class="devOps-modelFullRelease" :visible.sync="dialogVisible" width="80%" top="10px"
    :before-close="handleClose" :close-on-click-modal="false">
    <el-form size="mini" ref="form" :rules="rules" :model="form" label-width="100px">
      <el-form-item label="排除发布模块" prop="module_exclude">
        <el-select style="width: 100%" v-model="form.module_exclude" placeholder="默认发布当前所有模块" multiple>
          <el-option v-for="(item, index) in module_excludes" :key="index" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button :disabled="runLoading" type="warning" @click="releaseTipVisible = true">一键发布</el-button>
        <el-button type="success" @click="handleClose">关 闭</el-button>
      </el-form-item>
    </el-form>
    <Progress v-if="progressInfo.percentage" :progressInfo="progressInfo" />
    <TableFour v-if="tableData.length" :tableData="tableData" />

    <el-dialog title="提示" :visible.sync="releaseTipVisible" width="60%" center append-to-body>
      <div style="text-align:center;">是否确认发布？</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="onSubmit('run')">确 定</el-button>
        <el-button type="success" @click="releaseTipVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>
<script>
import {
  postDeployProdAllApi,
  getDevOpsSpaceListDeployProdAllApi,
} from "@/server/tops/devOps";

import { Progress } from "@/components/index.js";
import { TableFour } from "../table/index";
import { formatDate } from "../util";

export default {
  components: { Progress, TableFour },
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: () => {
        return function () { };
      },
    },
    modelParam: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      form: {
        module_exclude: [],
      },
      rules: {},
      runLoading: false,
      progressInfo: {
        customColor: "#1989fa",
        percentage: 0,
        title: "TOPS",
      },
      tableData: [],
      module_excludes: [],
      releaseTipVisible: false,
      msgPop: ''
    };
  },
  async mounted() {
    await this.queryDevOpsSpaceListDeployProdAllInfo();
  },
  methods: {
    // 获取select
    async queryDevOpsSpaceListDeployProdAllInfo() {
      try {
        const ret = await getDevOpsSpaceListDeployProdAllApi();
        if (ret?.status === "success") {
          if (ret?.data && Object.keys(ret.data).length > 0) {
            this.module_excludes = Object.keys(ret.data);
          } else {
            this.runLoading = true;
            this.msgPop = this.$notify({
              message: "暂无发布模块",
              type: "warning",
              duration: 2000,
            });
          }
        } else {
          this.msgPop = this.$notify({
            message: "获取select失败",
            type: "error",
          });
        }
      } catch (error) {
        this.msgPop = this.$notify({
          message: error || "获取select失败",
          type: "error",
        });
      }
    },
    // 关闭按钮
    handleClose() {
      this.msgPop && this.msgPop.close();
      this.hideDialogVisible("dialogVisibleFullRelease");
    },

    // 提交
    async onSubmit(action) {
      this.releaseTipVisible = false;
      action === "run" && (await this.queryActionRunSubmit("run"));
    },
    // 执行接口调用
    async queryActionRunSubmit() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.progressInfo = {
            ...this.progressInfo,
            customColor: "#1989fa",
            percentage: 30,
            completeInfo: "",
          };
          const { module_exclude = [] } = this.form;
          const param = {
            module_exclude: module_exclude.toString(),
          };
          try {
            const cacheDate = new Date();
            this.runLoading = true;
            const ret = await postDeployProdAllApi(param);
            if (ret?.data && ret.data.length > 0) {
              this.tableData = ret.data;
              this.progressInfo = {
                ...this.progressInfo,
                customColor: "",
                percentage: 100,
                status: "success",
                completeInfo:
                  "发布完成，用时：" +
                  formatDate(this, this.$moment(new Date()).diff(cacheDate)),
              };
            } else {
              this.progressInfo = {
                ...this.progressInfo,
                customColor: "",
                percentage: 100,
                status: "exception",
                completeInfo: "发布失败",
              };
            }
          } catch (error) {
            this.progressInfo = {
              ...this.progressInfo,
              customColor: "",
              percentage: 100,
              status: "exception",
              completeInfo: "发布失败",
            };
          } finally {
            this.runLoading = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.tips-message {
  max-height: 200px;
  overflow-y: scroll;
  white-space: pre-wrap;
  background: #f1fbec;
}
</style>
<style lang="scss">
.devOps-modelFullRelease {
  .el-input__inner {
    font-size: 14px !important;
  }

  .el-button--mini {
    padding: 12px 20px;
    font-size: 14px;
  }

  .el-dialog__header {
    border-bottom: 1px solid #efefef;
    font-weight: bold;
    padding: 20px 40px 10px;
  }

  .el-dialog__title,
  .el-form-item__label,
  .el-button {
    font-weight: bold;
  }

  .el-button {
    margin-right: 15px;
    letter-spacing: 2px;
    position: relative;

    .el-icon-loading {
      position: absolute;
      right: 5px;
    }
  }

  .el-form-item {
    margin-bottom: 12px;
  }
}
</style>
